import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AuthorizationService } from '../service/authorization.service';

/**
 * Forcing rebuild: #07
 */
@Component({
    selector: 'dhi-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
    public userPool: { UserPoolId: string; ClientId: string; env: string };
    public code: string;
    codeDisplay: string;
    public group: string;
    public userName: string;
    loginForm: FormGroup;
    cognitoUser: any;
    successMessage = false;
    errorMessage = false;

    confirmCode = false;
    codeWasConfirmed = false;
    error = '';

    showCode: string;

    error_messages = {
        password: [{ type: 'pattern', message: '8 character minimum with at least 1 number and 1 letter' }],
        confirmpassword: [{ type: 'pattern', message: '8 character minimum with at least 1 number and 1 letter' }],
    };

    constructor(
        public formBuilder: FormBuilder,
        private router: Router,
        @Inject(DOCUMENT) document: any,
        private httpClient: HttpClient,
        private auth: AuthorizationService,
        private _router: Router
    ) {}

    ngOnInit(): void {
        const { UserPoolId, ClientId, env, showCodeFlag } = window['DHI_AUTH_ENV'];
        this.userPool = { UserPoolId, ClientId, env };
        this.showCode = showCodeFlag;

        const url = document.location.href;

        const c = url.split('?c=').pop();
        this.code = c.split('&')[0];

        const g = url.split('&g=').pop();
        this.group = g.split('&')[0];

        this.userName = url.split('&u=').pop();

        this.loginForm = this.formBuilder.group(
            {
                password: new FormControl(
                    '',
                    Validators.compose([
                        Validators.required,
                        Validators.minLength(8),
                        Validators.maxLength(30),
                        Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[A-Za-z]).{8,30}'),
                    ])
                ),
                confirmpassword: new FormControl(
                    '',
                    Validators.compose([
                        Validators.required,
                        Validators.minLength(8),
                        Validators.maxLength(30),
                        Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[A-Za-z]).{8,30}'),
                    ])
                ),
                code: this.code,
            },
            {
                validators: this.passwordMatch.bind(this),
            }
        );
    }

    passwordMatch(formGroup: FormGroup) {
        const { value: password } = formGroup.get('password');
        const { value: confirmPassword } = formGroup.get('confirmpassword');
        return password === confirmPassword ? null : { passwordNotMatch: true };
    }

    onClickSubmit(form: NgForm) {
        if (this.loginForm.valid) {
            this.auth.confirmPassword(this.userName, this.code, form.value.password)
                .then( () => {
                    this.successMessage = true;
                    this.codeWasConfirmed = true;
                    this.confirmCode = false;

                    if (this.isCandidate()) {
                        setTimeout(() => {
                            window.location.href = `https://${this.userPool.env}/dashboard/login`;
                        }, 3000);
                    } else if (this.isRecruiter()) {
                        setTimeout(() => {
                            window.location.href = `https://${this.userPool.env}/employer/login`;
                        }, 3000);
                    }
                },
                (err) => {
                    console.log(err);
                    this.error = 'Confirm Authorization Error has occurred';
                    this.errorMessage = true;
                }
            );
        }
    }

    isRecruiter() {
        return this.group.startsWith('p');
    }

    isCandidate() {
        return this.group.startsWith('s');
    }
}
